import React from "react"
import { useDispatch } from "react-redux"
import CustomButton from "components/Atoms/CustomButton"
import CustomSpinner from "components/Atoms/CustomSpinner"
import Error from "components/Common/Error"
import SearchFilterTags from "./list/SearchFilterTags"
import { useDemandList } from "graphql/demand/demand.hooks"
import { DEMAND_RESET_FILTER } from "store/demand.redux"
import DemandHeader from "./DemandHeader"
import DemandList from "./list/DemandList"
import DemandSelectorAll from "./DemandSelectorAll"
const Demands = () => {
  const dispatch = useDispatch()
  const { data, loading, error } = useDemandList()
  if (error) return <Error message={error.message} />
  const demands = data?.allDemands?.demands ?? []

  window.scrollTo(0, 0)
  return (
    <div>
      <DemandHeader totalDemands={data?.allDemands?.totalCount ?? 0} />
      <div className="bg-gray-100 min-h-[75vh] p-3">
        <div className="vt-demand-filter-tags px-3">
          <SearchFilterTags />
        </div>

        <DemandSelectorAll demands={demands} />

        {loading ? (
          <CustomSpinner />
        ) : demands?.length > 0 ? (
          <DemandList demands={demands} />
        ) : (
          <Error
            icon="cross"
            message="No Demands Found!"
            className="mb-5"
            action={
              <CustomButton
                onClick={e => {
                  dispatch({
                    type: DEMAND_RESET_FILTER,
                  })
                }}
              >
                View All
              </CustomButton>
            }
          />
        )}
      </div>
    </div>
  )
}

export default Demands
